import WaveLoader from "./WaveLoader";

const PageLoader = ({ message }: { message?: string }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <WaveLoader className="w-[180px]" />
      {message && (
        <span className="block font-normal text-[12px] leading-[19.16px] tracking-[0.02em] text-center text-[#67749B] relative -top-[48px]">
          {message}
        </span>
      )}
    </div>
  );
};

export default PageLoader;
